import React, { Component } from 'react'
import commonUI from '../../../js/commonUI'
import DarkThemeNav from '../common/dark-theme-nav';

class Forms extends Component {

  constructor(props) {
    super(props)
    this.state = {
      formTheme: 'form--default',
    }
    this.handleChangeFormTheme = this.handleChangeFormTheme.bind(this)
  }

  handleChangeValidationState(e) {
    const selectedOption = e.target.value;

    if (selectedOption === 'success') {
      $('.validation-success-example').show();
      $('.validation-errors-example').hide();
    } else if (selectedOption === 'error') {
      $('.validation-errors-example').show();
      $('.validation-success-example').hide();
    }
  }

  handleChangeFormTheme(option) {
    const theme = option.target.value;
    this.setState({ formTheme: `form--${ theme }` });
  }

  render () {
    return(
    <section><a className="anchor"id="forms"></a>
      <h2>Forms</h2>
      <p>Forms should be simple, smart and consistent through all parts of the user experience. Form labels should always be placed above the field entry. Fields should have a minimum of twice the height of the field label in vertical space between fields. Field lengths and drop downs should be as consistent as possible from field to field and not vary. Required fields should always show a red * to the left of the field. </p>

      <h4>Default Form Titles, Category Headings &#38; Sub Category Headings</h4>

      <DarkThemeNav anchor="forms" />

      <div>
        <table className="table table--rows table--notop">
          <thead>
            <tr>
              <th></th>
              <th>Color</th>
              <th>Size</th>
              <th>Font Weight</th>
            </tr>
          </thead>
          <tbody>
          <tr style={{height: 50 + 'px'}}>
            <td><span className="form__title">Form Title Style</span></td>
            <td className="text--center">#25323c</td>
            <td className="text--center">21px</td>
            <td className="text--center">800</td>
          </tr>
          <tr style={{height: 50 + 'px'}}>
            <td><span className="form__category">Category Font Style</span></td>
            <td className="text--center">#5a6874</td>
            <td className="text--center">18px</td>
            <td className="text--center">Bold</td>
          </tr>
          <tr style={{height: 50 + 'px'}}>
            <td><span className="form__category-sub-helper">Form category sub helper text</span></td>
            <td className="text--center">#5a6874</td>
            <td className="text--center">11px</td>
            <td className="text--center">Normal</td>
          </tr>
          <tr style={{height: 50 + 'px'}}>
            <td><span className="form__sub-category">Sub Category Font Style</span></td>
            <td className="text--center">#8c9aa1</td>
            <td className="text--center">14px</td>
            <td className="text--center">800</td>
          </tr>
          <tr style={{height: 50 + 'px'}}>
            <td><label>labels capitalised by default</label></td>
            <td className="text--center">#25323C</td>
            <td className="text--center">12px</td>
            <td className="text--center">Normal</td>
          </tr>
          <tr style={{height: 50 + 'px'}}>
            <td><label className="label--uppercase">label uppercase</label></td>
            <td className="text--center">#25323C</td>
            <td className="text--center">12px</td>
            <td className="text--center">Normal</td>
          </tr>
          </tbody>
        </table>

        <pre><code className="language-html">{`<span class="form__title">Form Title Style</span>
<span class="form__category">Category Font Style</span>
<span class="form__category-sub-helper">Form category sub helper text</span>
<span class="form__sub-category">Sub Category Font Style</span>
<label>labels capitalised by default</label>
<label class="label--uppercase">label uppercase</label>`}</code></pre>
      </div>
      <br/>
      <br />
      <hr />

      <p>Wrap fields in a <code className="inline">&lt;ul class="form-fields"&gt;</code> to ensure correct spacing.</p>

      <h4>Textbox</h4>
      <ul className="form-fields grid hard">
        <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2 soft-half">
          <label htmlFor="firstName">Input (Default)</label>
          <input id="firstName" type="text" className="text-input" value="Dave" />
        </li>
        <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2 soft-half">
          <label htmlFor="firstName">Input (Readonly)</label>
          <input id="firstName" type="text" className="text-input" value="Input is readonly" readOnly />
        </li>
        <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2 soft-half">
          <label htmlFor="firstNameDisabled">Input (Disabled)</label>
          <input id="firstNameDisabled" type="text" className="text-input" value="Input is disabled" disabled />
        </li>
      </ul>

      <br />
      <h5 className="flush">Textbox - Size Options</h5>
      <ul className="form-fields grid hard">
        <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2 soft-half">
          <label htmlFor="firstNameXsmall">First Name (Xsmall)</label>
          <input id="firstNameXsmall" type="text" className="text-input text-input--xsmall" placeholder="Enter first name..." />
        </li>
        <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2 soft-half">
          <label htmlFor="firstNameDefault">First Name (Default)</label>
          <input id="firstNameDefault" type="text" className="text-input" placeholder="Enter first name..." />
        </li>
        <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2 soft-half">
          <label htmlFor="firstNameMedium">First Name (Medium)</label>
          <input id="firstNameMedium" type="text" className="text-input text-input--medium" placeholder="Enter first name..." />
        </li>
        <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2 soft-half">
          <label htmlFor="firstNameLarge">First Name (Large)</label>
          <input id="firstNameLarge" type="text" className="text-input text-input--large" placeholder="Enter first name..." />
        </li>
      </ul>
      <br/>
      <p>Add the following classes to set Textbox size.  Input width is set to fill 100% of the container it is in.</p>
      <pre>
        <code className="language-css">{`Xsmall:   .text-input .text-input--xsmall
Default:  .text-input
Medium:   .text-input .text-input--medium
Large:    .text-input .text-input--large`}
        </code>
      </pre>
      <br />
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
<pre className="hide-code"><code className="language-html">{`<ul className="form-fields grid hard">
  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 soft-half">
    <label htmlFor="firstNameXsmall">First Name (Xsmall)</label>
    <input id="firstNameXsmall" type="text" className="text-input text-input--xsmall" value="Angela" />
  </li>
  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 soft-half">
    <label htmlFor="firstNameDefault">First Name (Default)</label>
    <input id="firstNameDefault" type="text" className="text-input" value="Angela" />
  </li>
  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 soft-half">
    <label htmlFor="firstNameMedium">First Name (Medium)</label>
    <input id="firstNameMedium" type="text" className="text-input text-input--medium" value="Angela" />
  </li>
  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 soft-half">
    <label htmlFor="firstNameLarge">First Name (Large)</label>
    <input id="firstNameLarge" type="text" className="text-input text-input--large" value="Angela" />
  </li>
</ul>`}</code></pre>

    <br/>
    <h4>Multiline</h4>
    <ul className="form-fields grid hard">
      <li className="grid__col-xs-3 grid__col-sm-3 grid__col-md-3 grid__col-lg-3 soft-half">
        <label>What is your feedback? (Default)</label>
        <textarea className="text-input" name="comments" placeholder="Please enter your comments..."></textarea>
      </li>
      <li className="grid__col-xs-3 grid__col-sm-3 grid__col-md-3 grid__col-lg-3 soft-half">
        <label>What is your feedback? (Readonly)</label>
        <textarea className="text-input" name="comments" value="This content is readonly" readOnly></textarea>
      </li>
      <li className="grid__col-xs-3 grid__col-sm-3 grid__col-md-3 grid__col-lg-3 soft-half">
        <label>What is your feedback? (Disabled)</label>
        <textarea className="text-input" name="comments" value="This input is disabled" disabled></textarea>
      </li>
    </ul>

    <br />
    <h5 className="flush">Multiline - Size Options</h5>

    <ul className="form-fields grid hard">
      <li className="grid__col-xs-3 grid__col-sm-3 grid__col-md-3 grid__col-lg-3 soft-half">
        <label>What is your feedback? (Xsmall)</label>
        <textarea className="text-input--xsmall" name="comments" placeholder="Please enter your comments..."></textarea>
      </li>
      <li className="grid__col-xs-3 grid__col-sm-3 grid__col-md-3 grid__col-lg-3 soft-half">
        <label>What is your feedback? (Default)</label>
        <textarea className="text-input" name="comments" placeholder="Please enter your comments..."></textarea>
      </li>
      <li className="grid__col-xs-3 grid__col-sm-3 grid__col-md-3 grid__col-lg-3 soft-half">
        <label>What is your feedback? (Medium)</label>
        <textarea className="text-input--medium" name="comments" placeholder="Please enter your comments..."></textarea>
      </li>
      <li className="grid__col-xs-3 grid__col-sm-3 grid__col-md-3 grid__col-lg-3 soft-half">
        <label>What is your feedback? (Large)</label>
        <textarea className="text-input--large" name="comments" placeholder="Please enter your comments..."></textarea>
      </li>
    </ul>
    <br/>
      <p>Add the following classes to set Multiline size.  Input width is set to fill 100% of the container it is in.</p>
      <pre>
        <code className="language-css">{`Xsmall:   .text-input--xsmall
Default:  .text-input
Medium:   .text-input--medium
Large:    .text-input--large`}
        </code>
      </pre>
    <br/>
    <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
<pre className="hide-code"><code className="language-html">{`<ul class="form-fields">
  <li>
    <label>What is your feedback?</label>
    <textarea class="text-input--xsmall" name="comments" >Please enter your comments...</textarea>
  </li>
  <li>
    <label>What is your feedback?</label>
    <textarea class="text-input" name="comments" >Please enter your comments...</textarea>
  </li>
  <li>
    <label>What is your feedback?</label>
    <textarea class="text-input--medium" name="comments" >Please enter your comments...</textarea>
  </li>
  <li>
    <label>What is your feedback?</label>
    <textarea class="text-input--large" name="comments" >Please enter your comments...</textarea>
  </li>
</ul>`}</code></pre>

    <br/>
    <h4>Checkbox</h4>
    <ul className="form-fields grid hard">
      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">
        <label>Contact Method (Xsmall)</label>
        <ul className="check-list--xsmall">
            <li>
                <input type="checkbox" id="by-email-1" /> <label htmlFor="by-email-1">By email</label>
            </li>
            <li>
                <input type="checkbox" id="by-post-1" /> <label htmlFor="by-post-1">By post</label>
            </li>
            <li>
                <input type="checkbox" id="by-pigeon-1" checked /> <label htmlFor="by-pigeon-1">By carrier pigeon</label>
            </li>
        </ul>
      </li>
      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">
        <label>Contact Method (Default)</label>
        <ul className="check-list">
            <li>
                <input type="checkbox" id="by-email-2" checked /> <label htmlFor="by-email-2">By email</label>
            </li>
            <li>
                <input type="checkbox" id="by-post-2" /> <label htmlFor="by-post-2">By post</label>
            </li>
            <li>
                <input type="checkbox" id="by-pigeon-2" checked /> <label htmlFor="by-pigeon-2">By carrier pigeon</label>
            </li>
        </ul>
      </li>
      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">
        <label>Contact Method (Medium)</label>
        <ul className="check-list--medium">
            <li>
                <input type="checkbox" id="by-email-3" /> <label htmlFor="by-email-3">By email</label>
            </li>
            <li>
                <input type="checkbox" id="by-post-3" checked /> <label htmlFor="by-post-3">By post</label>
            </li>
            <li>
                <input type="checkbox" id="by-pigeon-3" /> <label htmlFor="by-pigeon-3">By carrier pigeon</label>
            </li>
        </ul>
      </li>
      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">
        <label>Contact Method (Large)</label>
        <ul className="check-list--large">
            <li>
                <input type="checkbox" id="by-email-4" checked /> <label htmlFor="by-email-4">By email</label>
            </li>
            <li>
                <input type="checkbox" id="by-post-4" /> <label htmlFor="by-post-4">By post</label>
            </li>
            <li>
                <input type="checkbox" id="by-pigeon-4" checked /> <label htmlFor="by-pigeon-4">By carrier pigeon</label>
            </li>
        </ul>
      </li>
    </ul>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
<pre className="hide-code"><code className="language-html">{`<ul className="form-fields grid hard">
  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">
    <label>Contact Method (Xsmall)</label>
    <ul className="check-list--xsmall">
        <li>
            <input type="checkbox" id="by-email-1" /> <label htmlFor="by-email-1">By email</label>
        </li>
        <li>
            <input type="checkbox" id="by-post-1" /> <label htmlFor="by-post-1">By post</label>
        </li>
        <li>
            <input type="checkbox" id="by-pigeon-1" checked /> <label htmlFor="by-pigeon-1">By carrier pigeon</label>
        </li>
    </ul>
  </li>
  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">
    <label>Contact Method (Default)</label>
    <ul className="check-list">
        <li>
            <input type="checkbox" id="by-email-2" checked /> <label htmlFor="by-email-2">By email</label>
        </li>
        <li>
            <input type="checkbox" id="by-post-2" /> <label htmlFor="by-post-2">By post</label>
        </li>
        <li>
            <input type="checkbox" id="by-pigeon-2" checked /> <label htmlFor="by-pigeon-2">By carrier pigeon</label>
        </li>
    </ul>
  </li>
  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">
    <label>Contact Method (Medium)</label>
    <ul className="check-list--medium">
        <li>
            <input type="checkbox" id="by-email-3" /> <label htmlFor="by-email-3">By email</label>
        </li>
        <li>
            <input type="checkbox" id="by-post-3" checked /> <label htmlFor="by-post-3">By post</label>
        </li>
        <li>
            <input type="checkbox" id="by-pigeon-3" /> <label htmlFor="by-pigeon-3">By carrier pigeon</label>
        </li>
    </ul>
  </li>
  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">
    <label>Contact Method (Large)</label>
    <ul className="check-list--large">
        <li>
            <input type="checkbox" id="by-email-4" checked /> <label htmlFor="by-email-4">By email</label>
        </li>
        <li>
            <input type="checkbox" id="by-post-4" /> <label htmlFor="by-post-4">By post</label>
        </li>
        <li>
            <input type="checkbox" id="by-pigeon-4" checked /> <label htmlFor="by-pigeon-4">By carrier pigeon</label>
        </li>
    </ul>
  </li>
</ul>`}</code></pre>
    <br/>
    <h4>Radio</h4>
    <ul className="form-fields grid">
      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">
        <label>Select your hero (Xsmall)</label>
        <ul className="check-list--xsmall">
            <li>
                <input type="radio" name="hero" id="Hector" checked /> <label htmlFor="Hector">Hector</label>
            </li>
            <li>
                <input type="radio" name="hero" id="Achilles" /> <label htmlFor="Achilles">Achilles</label>
            </li>
            <li>
              <input type="radio" name="hero" id="Agamemnon" /> <label htmlFor="Agamemnon">Agamemnon</label>
            </li>
        </ul>
      </li>
      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">
        <label>Select your hero (Default)</label>
        <ul className="check-list">
            <li>
                <input type="radio" name="hero1" id="Hector1" /> <label htmlFor="Hector1">Hector</label>
            </li>
            <li>
                <input type="radio" name="hero1" id="Achilles1" checked /> <label htmlFor="Achilles1">Achilles</label>
            </li>
            <li>
              <input type="radio" name="hero1" id="Agamemnon1" /> <label htmlFor="Agamemnon1">Agamemnon</label>
            </li>
        </ul>
      </li>
      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">
        <label>Select your hero (Medium)</label>
        <ul className="check-list--medium">
            <li>
                <input type="radio" name="hero2" id="Hector2" /> <label htmlFor="Hector2">Hector</label>
            </li>
            <li>
                <input type="radio" name="hero2" id="Achilles2" /> <label htmlFor="Achilles2">Achilles</label>
            </li>
            <li>
              <input type="radio" name="hero2" id="Agamemnon2" checked /> <label htmlFor="Agamemnon2">Agamemnon</label>
            </li>
        </ul>
      </li>
      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">
        <label>Select your hero (Large)</label>
        <ul className="check-list--large">
            <li>
                <input type="radio" name="hero3" id="Hector3" checked /> <label htmlFor="Hector3">Hector</label>
            </li>
            <li>
                <input type="radio" name="hero3" id="Achilles3" /> <label htmlFor="Achilles3">Achilles</label>
            </li>
            <li>
              <input type="radio" name="hero3" id="Agamemnon3" /> <label htmlFor="Agamemnon3">Agamemnon</label>
            </li>
        </ul>
      </li>
    </ul>
      <br/>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
<pre className="hide-code"><code className="language-html">{`<ul className="form-fields grid">
  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">
    <label>Select your hero (Xsmall)</label>
    <ul className="check-list--xsmall">
        <li>
            <input type="radio" name="hero" id="Hector" checked /> <label htmlFor="Hector">Hector</label>
        </li>
        <li>
            <input type="radio" name="hero" id="Achilles" /> <label htmlFor="Achilles">Achilles</label>
        </li>
        <li>
          <input type="radio" name="hero" id="Agamemnon" /> <label htmlFor="Agamemnon">Agamemnon</label>
        </li>
    </ul>
  </li>
  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">
    <label>Select your hero (Default)</label>
    <ul className="check-list">
        <li>
            <input type="radio" name="hero1" id="Hector1" /> <label htmlFor="Hector1">Hector</label>
        </li>
        <li>
            <input type="radio" name="hero1" id="Achilles1" checked /> <label htmlFor="Achilles1">Achilles</label>
        </li>
        <li>
          <input type="radio" name="hero1" id="Agamemnon1" /> <label htmlFor="Agamemnon1">Agamemnon</label>
        </li>
    </ul>
  </li>
  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">
    <label>Select your hero (Medium)</label>
    <ul className="check-list--medium">
        <li>
            <input type="radio" name="hero2" id="Hector2" /> <label htmlFor="Hector2">Hector</label>
        </li>
        <li>
            <input type="radio" name="hero2" id="Achilles2" /> <label htmlFor="Achilles2">Achilles</label>
        </li>
        <li>
          <input type="radio" name="hero2" id="Agamemnon2" checked /> <label htmlFor="Agamemnon2">Agamemnon</label>
        </li>
    </ul>
  </li>
  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">
    <label>Select your hero (Large)</label>
    <ul className="check-list--large">
        <li>
            <input type="radio" name="hero3" id="Hector3" checked /> <label htmlFor="Hector3">Hector</label>
        </li>
        <li>
            <input type="radio" name="hero3" id="Achilles3" /> <label htmlFor="Achilles3">Achilles</label>
        </li>
        <li>
          <input type="radio" name="hero3" id="Agamemnon3" /> <label htmlFor="Agamemnon3">Agamemnon</label>
        </li>
    </ul>
  </li>
</ul>`}</code></pre>
    <br/>
    <p>Add the following classes to the containing ul to resize radio and checkbox lists</p>
    <pre>
      <code className="language-css">{`Xsmall:   .check-list--xsmall
Default:  .check-list
Medium:   .check-list--medium
Large:    .check-list--large`}
      </code>
    </pre>
    <br/>

    <br/>
    <h4>Select</h4>
    <ul className="form-fields grid hard">
      <li className="grid__col-xs-3 grid__col-sm-3 grid__col-md-2 grid__col-lg-2 soft-half">
        <label htmlFor="countries">Select country (Default)</label>
        <select id="countries" name="countries" defaultValue="Aruba">
            <option>Argentina</option>
            <option>Albania</option>
            <option>Aruba</option>
        </select>
      </li>
      <li className="grid__col-xs-3 grid__col-sm-3 grid__col-md-2 grid__col-lg-2 soft-half">
        <label htmlFor="countries">Select country (Disabled)</label>
        <select id="countries" name="countries" defaultValue="Aruba" disabled>
            <option>Argentina</option>
            <option>Albania</option>
            <option>Aruba</option>
        </select>
      </li>
    </ul>

    <br />
    <h5 className="flush">Select - Size Options</h5>
    <ul className="form-fields grid hard">
      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2 soft-half">
        <label htmlFor="countries">Select country (Xsmall)</label>
        <select id="countries" name="countries" defaultValue="Argentina" className="select-input--xsmall">
            <option>Argentina</option>
            <option>Albania</option>
            <option>Aruba</option>
        </select>
      </li>
      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2 soft-half">
        <label htmlFor="countries">Select country (Default)</label>
        <select id="countries" name="countries" defaultValue="Argentina">
            <option>Argentina</option>
            <option>Albania</option>
            <option>Aruba</option>
        </select>
      </li>
      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2 soft-half">
        <label htmlFor="countries">Select country (Medium)</label>
        <select id="countries" name="countries" defaultValue="Argentina" className="select-input--medium">
            <option>Argentina</option>
            <option>Albania</option>
            <option>Aruba</option>
        </select>
      </li>
      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2 soft-half">
        <label htmlFor="countries">Select country (Large)</label>
        <select id="countries" name="countries" defaultValue="Argentina" className="select-input--large">
            <option>Argentina</option>
            <option>Albania</option>
            <option>Aruba</option>
        </select>
      </li>
    </ul>
    <br/>
      <p>Add the following classes to set Select size.  Input width is set to fill 100% of the container it is in.</p>
      <pre>
        <code className="language-css">{`Xsmall:   .select-input--xsmall
Medium:   .select-input--medium
Large:    .select-input--large`}
        </code>
      </pre>
      <br />
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
<pre className="hide-code"><code className="language-html">{`<ul class="form-fields">
  <li>
    <label for="countries">Select your country</label>
    <select id="countries" name="countries" class="select-input--xsmall">
        <option>Argentina</option>
        <option>Albania</option>
        <option selected="selected">Aruba</option>
    </select>
  </li>
  <li>
    <label for="countries">Select your country</label>
    <select id="countries" name="countries">
        <option>Argentina</option>
        <option>Albania</option>
        <option selected="selected">Aruba</option>
    </select>
  </li>
  <li>
    <label for="countries">Select your country</label>
    <select id="countries" name="countries" class="select-input--medium">
        <option>Argentina</option>
        <option>Albania</option>
        <option selected="selected">Aruba</option>
    </select>
  </li>
  <li>
    <label for="countries">Select your country</label>
    <select id="countries" name="countries" class="select-input--large">
        <option>Argentina</option>
        <option>Albania</option>
        <option selected="selected">Aruba</option>
    </select>
  </li>
</ul>`}</code></pre>
      <br/>

      <h4>Validation</h4>

      <p>
        Form validation should always be done inline. Error messaging should highlight the row and provide messaging underneath.
        Below is the 3 styles of validation that can be used based on the preference of the designer / application that is going to use it. Please note that these styles are not intended to be used in a mix 'n' match type scenario and how they are presented below in 
        groups is how its expected to be used via form design and development.
      </p>

      <div style={{ width: 100 + 'px' }}>
        <select id="validation-state-select" onChange={this.handleChangeValidationState}>
          <option value="error" selected>Error</option>
          <option value="success">Success</option>
        </select>
      </div>

      <div className="grid hard flush validation-success-example" style={{ display: 'none' }}>
        <div className="grid__col-xs-6 grid__col-sm-6 grid__col-md-4 grid__col-lg-4 hard">
          <h3 className="flush">
            <label className="label--uppercase soft-half" style={{ display: 'inline' }}>Default</label>
            <label style={{textTransform: "lowercase", display: 'inline'}}>(.is-valid)</label>
          </h3>
          <ul className="form-fields soft-half max-width--80">
            <li className="push-half--bottom">
              <label htmlFor="defaultSuccessText">Success - outline &#38; text</label>
              <input id="defaultSuccessText" type="text" className="text-input is-valid"/>
              <span className="feedback"></span>
              <div className="success">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
            <label htmlFor="defaultErrorSelect">Success - outline &#38; text</label>
              <select id="countries" name="defaultErrorSelect" defaultValue="Argentina" className="is-valid">
                <option>Argentina</option>
                <option>Albania</option>
                <option>Aruba</option>
              </select>
              <div className="success">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <label htmlFor="defaultErrorTextarea">Success - outline &#38; text</label>
              <textarea className="text-input is-valid" name="defaultErrorTextarea" >Please enter your comments...</textarea>
              <span className="feedback"></span>
              <div className="success">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <label htmlFor="defaultValidCalIcon">Calendar</label>
              <input id="defaultValidCalIcon" type="text" className="text-input is-valid"/>
              <div className="icon__wrapper icon__wrapper--datepicker">
                <i className="far fa-calendar-alt"></i>
              </div>
              <div className="success">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <label>Units</label>
              <input type="text" className="text-input has-unit-text is-valid"/>
              <div className="input__unit-text">
                  Kg
              </div>
              <div className="success">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <ul className="check-list list-inline is-valid">
                <li className="push--right">
                    <input type="radio" name="radio-valid-validation-1" id="radio1yes" /> <label htmlFor="radio1yes">Yes</label>
                </li>
                <li>
                    <input type="radio" name="radio-valid-validation-1" id="radio1no" checked /> <label htmlFor="radio1no">No</label>
                </li>
              </ul>
              <div className="success">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <ul className="check-list is-valid">
                <li>
                    <input type="checkbox" id="accept-terms-valid-1" /> <label htmlFor="accept-terms-valid-1">Accept Terms &#38; Conditions</label>
                </li>
              </ul>
              <div className="success">This is the validation message</div>
            </li>
          </ul>
        </div>
        <div className="grid__col-xs-6 grid__col-sm-6 grid__col-md-4 grid__col-lg-4 hard">
          <h3 className="flush">
            <label className="label--uppercase soft-half" style={{ display: 'inline' }}>With Icon</label>
            <label style={{ textTransform: 'lowercase', display: 'inline' }}>(.is-valid--icon)</label>
          </h3>
          <ul className="form-fields soft-half max-width--80">
            <li className="push-half--bottom">
              <label htmlFor="defaultErrorText">Success - outline with Icon &#38; Text</label>
              <input id="defaultErrorText" type="text" className="text-input is-valid--icon"/>
              <i className="fas fa-check feedback"></i>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
            <label htmlFor="defaultErrorSelect">Success - outline &#38; Text</label>
              <select id="countries" name="defaultErrorSelect" defaultValue="Argentina" className="is-valid--icon">
                <option>Argentina</option>
                <option>Albania</option>
                <option>Aruba</option>
              </select>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <label htmlFor="defaultErrorText">Success - outline with Icon &#38; Text</label>
              <textarea className="text-input is-valid--icon" name="comments" >Please enter your comments...</textarea>
              <i className="fas fa-check feedback"></i>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <label htmlFor="defaultErrorTextarea">Calendar</label>
              <input id="defaultErrorTextarea" type="text" className="text-input is-valid--icon"/>
              <div className="icon__wrapper icon__wrapper--datepicker">
                <i className="far fa-calendar-alt"></i>
              </div>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <label>Units</label>
              <input type="text" className="text-input has-unit-text is-valid--icon"/>
              <div className="input__unit-text">
                  Kg
              </div>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <ul className="check-list list-inline is-valid--icon">
                <li className="push--right">
                    <input type="radio" name="radio-valid-validation-2" id="radio2yes" /> <label htmlFor="radio2yes">Yes</label>
                </li>
                <li>
                    <input type="radio" name="radio-valid-validation-2" id="radio2no" checked /> <label htmlFor="radio2no">No</label>
                </li>
              </ul>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <ul className="check-list is-valid--icon">
                <li>
                    <input type="checkbox" id="accept-terms-valid-2" checked /> <label htmlFor="accept-terms-valid-2">Accept Terms &#38; Conditions</label>
                </li>
              </ul>
              <div className="error">This is the validation message</div>
            </li>
          </ul>
        </div>
        <div className="grid__col-xs-6 grid__col-sm-6 grid__col-md-4 grid__col-lg-4 hard">
          <h3 className="flush">
            <label className="label--uppercase soft-half"  style={{ display: 'inline' }}>Minimal</label>
            <label style={{textTransform: "lowercase", display: 'inline'}}>(.is-valid--minimal)</label>
          </h3>
          <ul className="form-fields soft-half max-width--80">
            <li className="push-half--bottom">
              <label htmlFor="defaultErrorText">Success - text &#38; no icon</label>
              <input id="defaultErrorText" type="text" className="text-input is-valid--minimal"/>
              <span className="feedback"></span>
              <div className="success">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <label htmlFor="defaultErrorSelect">Success - text &#38; no icon</label>
              <select id="countries" name="defaultErrorSelect" defaultValue="Argentina" className="is-valid--minimal">
                <option>Argentina</option>
                <option>Albania</option>
                <option>Aruba</option>
              </select>
              <div className="success">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <label htmlFor="defaultErrorText">Success - text &#38; no icon</label>
              <textarea className="text-input is-valid--minimal" name="comments" >Please enter your comments...</textarea>
              <span className="feedback"></span>
              <div className="success">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <label htmlFor="defaultErrorTextarea">Calendar</label>
              <input id="defaultErrorTextarea" type="text" className="text-input is-valid--minimal"/>
              <div className="icon__wrapper icon__wrapper--datepicker">
                <i className="far fa-calendar-alt"></i>
              </div>
              <div className="success">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <label>Units</label>
              <input type="text" className="text-input has-unit-text is-valid--minimal"/>
              <div className="input__unit-text">
                  Kg
              </div>
              <div className="success">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <ul className="check-list list-inline is-valid--minimal">
                <li className="push--right">
                    <input type="radio" name="radio-valid-validation-3" id="radio3yes" /> <label htmlFor="radio3yes">Yes</label>
                </li>
                <li>
                    <input type="radio" name="radio-valid-validation-3" id="radio3no" checked /> <label htmlFor="radio3no">No</label>
                </li>
              </ul>
              <span className="feedback"></span>
              <div className="success">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <ul className="check-list is-valid--minimal">
                <li>
                    <input type="checkbox" id="accept-terms-valid-3" /> <label htmlFor="accept-terms-valid-3">Accept Terms &#38; Conditions</label>
                </li>
              </ul>
              <div className="success">This is the validation message</div>
            </li>
          </ul>
        </div>
      </div>

      <button type="button" className="btn btn--secondary show-code validation-success-example" style={{ display: 'none' }}>
        <i className="fa fa-plus"></i>View source
      </button>
      <br/><br/>
      <pre className="hide-code"><code className="language-html validation-success-example">{`Validation Success - Default:

<ul class="form-fields">
  <li>
    <label htmlFor="defaultValidText">Error - outline and text</label>
    <input id="defaultValidText" type="text" class="text-input is-valid"/>
    <span class="feedback"></span>
    <div class="success">This is the validation message</div>
  </li>
  <li>
  <label htmlFor="defaultValidSelect">Error - outline and text</label>
    <select id="countries" name="defaultValidSelect" defaultValue="Argentina" class="is-valid">
      <option>Argentina</option>
      <option>Albania</option>
      <option>Aruba</option>
    </select>
    <div class="success">This is the validation message</div>
  </li>
  <li>
    <label htmlFor="defaultValidTextarea">Error - outline and text</label>
    <textarea class="text-input is-valid" name="defaultValidTextarea" >Please enter your comments...</textarea>
    <span class="feedback"></span>
    <div class="success">This is the validation message</div>
  </li>
  <li>
    <label htmlFor="defaultValidCalIcon">Calendar</label>
    <input id="defaultValidCalIcon" type="text" class="text-input is-valid"/>
    <div class="icon__wrapper icon__wrapper--datepicker">
      <i class="far fa-calendar-alt"></i>
    </div>
    <div class="success">This is a required field</div>
  </li>
  <li>
    <label htmlFor="defaultValidUnit">Units</label>
    <input type="text" class="text-input has-unit-text is-valid" name="defaultValidUnit" />
    <div class="input__unit-text">
        Kg
    </div>
    <div class="success">This is a required field</div>
  </li>
  <li>
    <ul class="check-list list-inline is-valid">
      <li class="push--right">
          <input type="radio" name="radio-validation-1" id="radio1yes" /> <label htmlFor="radio1yes">Yes</label>
      </li>
      <li>
          <input type="radio" name="radio-validation-1" id="radio1no" checked /> <label htmlFor="radio1no">No</label>
      </li>
    </ul>
    <div class="success">This is the validation message</div>
  </li>
  <li>
    <ul class="check-list is-valid">
      <li>
          <input type="checkbox" id="accept-terms-1" /> <label htmlFor="accept-terms-1">Accept Terms &#38; Conditions</label>
      </li>
    </ul>
    <div class="success">This is the validation message</div>
  </li>
</ul>

Validation Success - With icon:

<ul class="form-fields">
  <li>
    <label htmlFor="defaultValidText">Error - outline, icon & text</label>
    <input id="defaultValidText" type="text" class="text-input is-valid--icon"/>
    <i class="fas fa-check feedback"></i>
    <div class="success">This is the validation message</div>
  </li>
  <li>
  <label htmlFor="defaultValidSelect">Error - outline, icon & text</label>
    <select id="countries" name="defaultValidSelect" defaultValue="Argentina" class="is-valid--icon">
      <option>Argentina</option>
      <option>Albania</option>
      <option>Aruba</option>
    </select>
    <div class="success">This is the validation message</div>
  </li>
  <li>
    <label htmlFor="defaultValidTextarea">Error - outline and text</label>
    <textarea class="text-input is-valid--icon" name="defaultValidTextarea" >Please enter your comments...</textarea>
    <i class="fas fa-check feedback"></i>
    <div class="success">This is the validation message</div>
  </li>
  <li>
    <label htmlFor="defaultValidCalIcon">Calendar</label>
    <input id="defaultValidCalIcon" type="text" class="text-input is-valid--icon"/>
    <div class="icon__wrapper icon__wrapper--datepicker">
      <i class="far fa-calendar-alt"></i>
    </div>
    <div class="success">This is a required field</div>
  </li>
  <li>
    <label htmlFor="defaultValidUnit">Units</label>
    <input type="text" class="text-input has-unit-text is-valid--icon" name="defaultValidUnit" />
    <div class="input__unit-text">
        Kg
    </div>
    <div class="success">This is a required field</div>
  </li>
  <li>
    <ul class="check-list list-inline is-valid--icon">
      <li class="push--right">
          <input type="radio" name="radio-validation-1" id="radio1yes" /> <label htmlFor="radio1yes">Yes</label>
      </li>
      <li>
          <input type="radio" name="radio-validation-1" id="radio1no" checked /> <label htmlFor="radio1no">No</label>
      </li>
    </ul>
    <div class="success">This is the validation message</div>
  </li>
  <li>
    <ul class="check-list is-valid--icon">
      <li>
          <input type="checkbox" id="accept-terms-1" /> <label htmlFor="accept-terms-1">Accept Terms &#38; Conditions</label>
      </li>
    </ul>
    <div class="success">This is the validation message</div>
  </li>
</ul>

Validation Success - Minimal:

<ul class="form-fields">
  <li>
    <label htmlFor="defaultValidText">Error - Text & No Icon</label>
    <input id="defaultValidText" type="text" class="text-input is-valid--minimal"/>
    <span class="feedback"></span>
    <div class="success">This is the validation message</div>
  </li>
  <li>
  <label htmlFor="defaultValidSelect">Error - Text & No Icon</label>
    <select id="countries" name="defaultValidSelect" defaultValue="Argentina" class="is-valid--minimal">
      <option>Argentina</option>
      <option>Albania</option>
      <option>Aruba</option>
    </select>
    <div class="success">This is the validation message</div>
  </li>
  <li>
    <label htmlFor="defaultValidTextarea">Error - Text & No Icon</label>
    <textarea class="text-input is-valid--minimal" name="defaultValidTextarea" >Please enter your comments...</textarea>
    <span class="feedback"></span>
    <div class="success">This is the validation message</div>
  </li>
  <li>
    <label htmlFor="defaultValidCalIcon">Calendar</label>
    <input id="defaultValidCalIcon" type="text" class="text-input is-valid--minimal"/>
    <div class="icon__wrapper icon__wrapper--datepicker">
      <i class="far fa-calendar-alt"></i>
    </div>
    <div class="success">This is a required field</div>
  </li>
  <li>
    <label htmlFor="defaultValidUnit">Units</label>
    <input type="text" class="text-input has-unit-text is-valid--minimal" name="defaultValidUnit" />
    <div class="input__unit-text">
        Kg
    </div>
    <div class="success">This is a required field</div>
  </li>
  <li>
    <ul class="check-list list-inline is-valid--minimal">
      <li class="push--right">
          <input type="radio" name="radio-validation-1" id="radio1yes" /> <label htmlFor="radio1yes">Yes</label>
      </li>
      <li>
          <input type="radio" name="radio-validation-1" id="radio1no" checked /> <label htmlFor="radio1no">No</label>
      </li>
    </ul>
    <div class="success">This is the validation message</div>
  </li>
  <li>
    <ul class="check-list is-valid--minimal">
      <li>
          <input type="checkbox" id="accept-terms-1" /> <label htmlFor="accept-terms-1">Accept Terms &#38; Conditions</label>
      </li>
    </ul>
    <div class="success">This is the validation message</div>
  </li>
</ul>`}</code></pre>

      <div className="grid hard flush validation-errors-example">
        <div className="grid__col-xs-6 grid__col-sm-6 grid__col-md-4 grid__col-lg-4 hard">
          <h3 className="flush">
            <label className="label--uppercase soft-half" style={{ display: 'inline' }}>Default</label>
            <label style={{textTransform: "lowercase", display: 'inline'}}>(.has-error)</label>
          </h3>
          <ul className="form-fields soft-half max-width--80">
            <li className="push-half--bottom">
              <label htmlFor="defaultErrorText">Error - outline &#38; text</label>
              <input id="defaultErrorText" type="text" className="text-input has-error"/>
              <span className="feedback"></span>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
            <label htmlFor="defaultErrorSelect">Error - outline &#38; text</label>
              <select id="countries" name="defaultErrorSelect" defaultValue="Argentina" className="has-error">
                <option>Argentina</option>
                <option>Albania</option>
                <option>Aruba</option>
              </select>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <label htmlFor="defaultErrorText">Error - outline &#38; text</label>
              <textarea className="text-input has-error" name="comments" >Please enter your comments...</textarea>
              <span className="feedback"></span>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <label htmlFor="defaultErrorTextarea">Calendar</label>
              <input id="defaultErrorTextarea" type="text" className="text-input has-error"/>
              <div className="icon__wrapper icon__wrapper--datepicker">
                <i className="far fa-calendar-alt"></i>
              </div>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <label>Units</label>
              <input type="text" className="text-input has-unit-text has-error"/>
              <div className="input__unit-text">
                  Kg
              </div>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <ul className="check-list list-inline has-error">
                <li className="push--right">
                    <input type="radio" name="radio-validation-1" id="radio1yes" /> <label htmlFor="radio1yes">Yes</label>
                </li>
                <li>
                    <input type="radio" name="radio-validation-1" id="radio1no" checked /> <label htmlFor="radio1no">No</label>
                </li>
              </ul>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <ul className="check-list has-error">
                <li>
                    <input type="checkbox" id="accept-terms-1" /> <label htmlFor="accept-terms-1">Accept Terms &#38; Conditions</label>
                </li>
              </ul>
              <div className="error">This is the validation message</div>
            </li>
          </ul>
        </div>
        <div className="grid__col-xs-6 grid__col-sm-6 grid__col-md-4 grid__col-lg-4 hard">
          <h3 className="flush">
            <label className="label--uppercase soft-half" style={{ display: 'inline' }}>With Icon</label>
            <label style={{ textTransform: "lowercase", display: 'inline' }}>(.has-error--icon)</label>
          </h3>
          <ul className="form-fields soft-half max-width--80">
            <li className="push-half--bottom">
              <label htmlFor="defaultErrorText">Error - outline, icon &#38; text</label>
              <input id="defaultErrorText" type="text" className="text-input has-error--icon"/>
              <span className="feedback"></span>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
            <label htmlFor="defaultErrorSelect">Error - outline &#38; text</label>
              <select id="countries" name="defaultErrorSelect" defaultValue="Argentina" className="has-error">
                <option>Argentina</option>
                <option>Albania</option>
                <option>Aruba</option>
              </select>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <label htmlFor="defaultErrorText">Error - outline, icon &#38; text</label>
              <textarea className="text-input has-error--icon" name="comments" >Please enter your comments...</textarea>
              <i className="fas fa-times feedback"></i>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <label htmlFor="defaultErrorTextarea">Calendar</label>
              <input id="defaultErrorTextarea" type="text" className="text-input has-error"/>
              <div className="icon__wrapper icon__wrapper--datepicker">
                <i className="far fa-calendar-alt"></i>
              </div>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <label>Units</label>
              <input type="text" className="text-input has-unit-text has-error"/>
              <div className="input__unit-text">
                  Kg
              </div>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <ul className="check-list list-inline has-error">
                <li className="push--right">
                    <input type="radio" name="radio-validation-2" id="radio2yes" /> <label htmlFor="radio2yes">Yes</label>
                </li>
                <li>
                    <input type="radio" name="radio-validation-2" id="radio2no" checked /> <label htmlFor="radio2no">No</label>
                </li>
              </ul>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <ul className="check-list has-error">
                <li>
                    <input type="checkbox" id="accept-terms-2" checked /> <label htmlFor="accept-terms-2">Accept Terms &#38; Conditions</label>
                </li>
              </ul>
              <div className="error">This is the validation message</div>
            </li>
          </ul>
        </div>
        <div className="grid__col-xs-6 grid__col-sm-6 grid__col-md-4 grid__col-lg-4 hard">
          <h3 className="flush">
            <label className="label--uppercase soft-half"  style={{ display: 'inline' }}>Minimal</label>
            <label style={{textTransform: "lowercase", display: 'inline'}}>(.has-error--minimal)</label>
          </h3>
          <ul className="form-fields soft-half max-width--80">
            <li className="push-half--bottom">
              <label htmlFor="defaultErrorText">Error - text &#38; no icon</label>
              <input id="defaultErrorText" type="text" className="text-input has-error--minimal"/>
              <span className="feedback"></span>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <label htmlFor="defaultErrorSelect">Error - text &#38; no icon</label>
              <select id="countries" name="defaultErrorSelect" defaultValue="Argentina" className="has-error--minimal">
                <option>Argentina</option>
                <option>Albania</option>
                <option>Aruba</option>
              </select>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <label htmlFor="defaultErrorText">Error - text &#38; no icon</label>
              <textarea className="text-input has-error--minimal" name="comments" >Please enter your comments...</textarea>
              <span className="feedback"></span>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <label htmlFor="defaultErrorTextarea">Calendar</label>
              <input id="defaultErrorTextarea" type="text" className="text-input has-error--minimal"/>
              <div className="icon__wrapper icon__wrapper--datepicker">
                <i className="far fa-calendar-alt"></i>
              </div>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <label>Units</label>
              <input type="text" className="text-input has-unit-text has-error--minimal"/>
              <div className="input__unit-text">
                  Kg
              </div>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <ul className="check-list list-inline has-error--minimal">
                <li className="push--right">
                    <input type="radio" name="radio-validation-3" id="radio3yes" /> <label htmlFor="radio3yes">Yes</label>
                </li>
                <li>
                    <input type="radio" name="radio-validation-3" id="radio3no" checked /> <label htmlFor="radio3no">No</label>
                </li>
              </ul>
              <span className="feedback"></span>
              <div className="error">This is the validation message</div>
            </li>
            <li className="push-half--bottom">
              <ul className="check-list has-error--minimal">
                <li>
                    <input type="checkbox" id="accept-terms-3" /> <label htmlFor="accept-terms-3">Accept Terms &#38; Conditions</label>
                </li>
              </ul>
              <div className="error">This is the validation message</div>
            </li>
          </ul>
        </div>
      </div>

      <br/>

      <button type="button" className="btn btn--secondary show-code validation-errors-example"><i className="fa fa-plus"></i>View source</button><br/><br/>
<pre className="hide-code"><code className="language-html validation-errors-example">{`Validation Error - Default:

<ul class="form-fields">
  <li>
    <label htmlFor="defaultErrorText">Error - outline and text</label>
    <input id="defaultErrorText" type="text" class="text-input has-error"/>
    <span class="feedback"></span>
    <div class="error">This is the validation message</div>
  </li>
  <li>
  <label htmlFor="defaultErrorSelect">Error - outline and text</label>
    <select id="countries" name="defaultErrorSelect" defaultValue="Argentina" class="has-error">
      <option>Argentina</option>
      <option>Albania</option>
      <option>Aruba</option>
    </select>
    <div class="error">This is the validation message</div>
  </li>
  <li>
    <label htmlFor="defaultErrorText">Error - outline and text</label>
    <textarea class="text-input has-error" name="comments" >Please enter your comments...</textarea>
    <span class="feedback"></span>
    <div class="error">This is the validation message</div>
  </li>
  <li>
    <label htmlFor="defaultErrorTextarea">Calendar</label>
    <input id="defaultErrorTextarea" type="text" class="text-input has-error"/>
    <div class="icon__wrapper icon__wrapper--datepicker">
      <i class="far fa-calendar-alt"></i>
    </div>
    <div class="error">This is a required field</div>
  </li>
  <li>
    <label>Units</label>
    <input type="text" class="text-input has-unit-text has-error"/>
    <div class="input__unit-text">
        Kg
    </div>
    <div class="error">This is a required field</div>
  </li>
  <li>
    <ul class="check-list list-inline has-error">
      <li class="push--right">
          <input type="radio" name="radio-validation-1" id="radio1yes" /> <label htmlFor="radio1yes">Yes</label>
      </li>
      <li>
          <input type="radio" name="radio-validation-1" id="radio1no" checked /> <label htmlFor="radio1no">No</label>
      </li>
    </ul>
    <div class="error">This is the validation message</div>
  </li>
  <li>
    <ul class="check-list has-error">
      <li>
          <input type="checkbox" id="accept-terms-1" /> <label htmlFor="accept-terms-1">Accept Terms &#38; Conditions</label>
      </li>
    </ul>
    <div class="error">This is the validation message</div>
  </li>
</ul>

Validation Error - With icon:

<ul class="form-fields">
  <li>
    <label htmlFor="defaultErrorText">Error - outline and text</label>
    <input id="defaultErrorText" type="text" class="text-input has-error--icon"/>
    <i class="fas fa-times feedback"></i>
    <div class="error">This is the validation message</div>
  </li>
  <li>
  <label htmlFor="defaultErrorSelect">Error - outline and text</label>
    <select id="countries" name="defaultErrorSelect" defaultValue="Argentina" class="has-error--icon">
      <option>Argentina</option>
      <option>Albania</option>
      <option>Aruba</option>
    </select>
    <div class="error">This is the validation message</div>
  </li>
  <li>
    <label htmlFor="defaultErrorText">Error - outline and text</label>
    <textarea class="text-input has-error--icon" name="comments" >Please enter your comments...</textarea>
    <i class="fas fa-times feedback"></i>
    <div class="error">This is the validation message</div>
  </li>
  <li>
    <label htmlFor="defaultErrorTextarea">Calendar</label>
    <input id="defaultErrorTextarea" type="text" class="text-input has-error--icon"/>
    <div class="icon__wrapper icon__wrapper--datepicker">
      <i class="far fa-calendar-alt"></i>
    </div>
    <div class="error">This is a required field</div>
  </li>
  <li>
    <label>Units</label>
    <input type="text" class="text-input has-unit-text has-error--icon"/>
    <div class="input__unit-text">
        Kg
    </div>
    <div class="error">This is a required field</div>
  </li>
  <li>
    <ul class="check-list list-inline has-error--icon">
      <li class="push--right">
          <input type="radio" name="radio-validation-1" id="radio1yes" /> <label htmlFor="radio1yes">Yes</label>
      </li>
      <li>
          <input type="radio" name="radio-validation-1" id="radio1no" checked /> <label htmlFor="radio1no">No</label>
      </li>
    </ul>
    <div class="error">This is the validation message</div>
  </li>
  <li>
    <ul class="check-list has-error--icon">
      <li>
          <input type="checkbox" id="accept-terms-1" /> <label htmlFor="accept-terms-1">Accept Terms &#38; Conditions</label>
      </li>
    </ul>
    <div class="error">This is the validation message</div>
  </li>
</ul>

Validation Error - Minimal:

<ul class="form-fields">
  <li>
    <label htmlFor="defaultErrorText">Error - outline and text</label>
    <input id="defaultErrorText" type="text" class="text-input has-error--minimal"/>
    <span class="feedback"></span>
    <div class="error">This is the validation message</div>
  </li>
  <li>
    <label htmlFor="defaultErrorSelect">Error - outline and text</label>
    <select id="countries" name="defaultErrorSelect" defaultValue="Argentina" class="has-error--minimal">
      <option>Argentina</option>
      <option>Albania</option>
      <option>Aruba</option>
    </select>
    <div class="error">This is the validation message</div>
  </li>
  <li>
    <label htmlFor="defaultErrorText">Error - outline and text</label>
    <textarea class="text-input has-error--minimal" name="comments" >Please enter your comments...</textarea>
    <span class="feedback"></span>
    <div class="error">This is the validation message</div>
  </li>
  <li>
    <label htmlFor="defaultErrorTextarea">Calendar</label>
    <input id="defaultErrorTextarea" type="text" class="text-input has-error--minimal"/>
    <div class="icon__wrapper icon__wrapper--datepicker">
      <i class="far fa-calendar-alt"></i>
    </div>
    <div class="error">This is a required field</div>
  </li>
  <li>
    <label>Units</label>
    <input type="text" class="text-input has-unit-text has-error--minimal"/>
    <div class="input__unit-text">
        Kg
    </div>
    <div class="error">This is a required field</div>
  </li>
  <li>
    <ul class="check-list list-inline has-error--minimal">
      <li class="push--right">
          <input type="radio" name="radio-validation-3" id="radio3yes" /> <label htmlFor="radio3yes">Yes</label>
      </li>
      <li>
          <input type="radio" name="radio-validation-3" id="radio3no" checked /> <label htmlFor="radio3no">No</label>
      </li>
    </ul>
    <span class="feedback"></span>
    <div class="error">This is the validation message</div>
  </li>
  <li>
    <ul class="check-list has-error--minimal">
      <li>
          <input type="checkbox" id="accept-terms-3" /> <label htmlFor="accept-terms-3">Accept Terms &#38; Conditions</label>
      </li>
    </ul>
    <div class="error">This is the validation message</div>
  </li>
</ul>`}</code></pre>

      <h4>Validation - Required/Optional display</h4>

      <p>
        Displaying required or optional labels should be positioned to the top-right of the input. 
        Each form must either display the required fields label only or the optional fields label only - do not mix the presentation of these indicatators on forms and always lean towards using the option that will present the indicator the least.
      </p>

      <div className="display--inline-block max-width--50 soft-half">
        <h5>Required</h5>
        <ul className="form-fields grid max-width--90">
          <li className="required push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
            <label htmlFor="requiredExample1">Username</label>
            <input id="requiredExample1" type="text" className="text-input has-error--icon"/>
            <span className="feedback"></span>
            <div className="error">This is the validation message</div>
          </li>
          <li className="required push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
              <label htmlFor="defaultErrorText">Error - outline, icon &#38; text</label>
              <input id="defaultErrorText" type="text" className="text-input has-error--icon"/>
              <span className="feedback"></span>
              <div className="error">This is the validation message</div>
            </li>
          <li className="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
            <label htmlFor="requiredExample2">Select Country</label>
            <select id="countries" name="requiredExample2" defaultValue="Argentina">
              <option>Argentina</option>
              <option>Albania</option>
              <option>Aruba</option>
            </select>
            <div className="error">This is the validation message</div>
          </li>
          <li className="push-half--bottom grid__col-12">
            <label htmlFor="requiredExample3">Comments</label>
            <textarea className="text-input" name="requiredExample3" >Please enter your comments...</textarea>
            <span className="feedback"></span>
            <div className="error">This is the validation message</div>
          </li>
          <li className="required push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
            <label htmlFor="requiredExample4">Calendar</label>
            <input id="requiredExample4" type="text" className="text-input"/>
            <div className="icon__wrapper icon__wrapper--datepicker">
              <i className="far fa-calendar-alt"></i>
            </div>
            <div className="error">This is the validation message</div>
          </li>
          <li className="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
            <label htmlFor="requiredExample5">Units</label>
            <input type="text" name="requiredExample5" className="text-input has-unit-text"/>
            <div className="input__unit-text">
              Kg
            </div>
            <div className="error">This is the validation message</div>
          </li>
          <li className="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
            <ul className="check-list list-inline">
              <li className="push--right">
                  <input type="radio" name="requiredExampleRadio" id="required1yes" /> <label htmlFor="required1yes">Yes</label>
              </li>
              <li>
                  <input type="radio" name="requiredExampleRadio" id="required1no" checked /> <label htmlFor="required1no">No</label>
              </li>
            </ul>
            <div className="error">This is the validation message</div>
          </li>
          <li className="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
            <ul className="check-list">
              <li>
                  <input type="checkbox" id="requiredExampleTerms" /> <label htmlFor="requiredExampleTerms">Accept Terms &#38; Conditions</label>
              </li>
            </ul>
            <div className="error">This is the validation message</div>
          </li>
        </ul>
      </div>

      <div className="display--inline-block max-width--50 soft-half">
        <h5>Optional</h5>
        <ul className="form-fields grid max-width--90">
          <li className="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
            <label htmlFor="optionalExample1">Username</label>
            <input id="optionalExample1" type="text" className="text-input"/>
            <span className="feedback"></span>
            <div className="error">This is the validation message</div>
          </li>
          <li className="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
          <label htmlFor="optionalExample2">Select Country</label>
            <select id="countries" name="optionalExample2" defaultValue="Argentina">
              <option>Argentina</option>
              <option>Albania</option>
              <option>Aruba</option>
            </select>
            <div className="error">This is the validation message</div>
          </li>
          <li className="push-half--bottom optional grid__col-12">
            <label htmlFor="optionalExample3">Comments</label>
            <textarea className="text-input" name="optionalExample3" >Please enter your comments...</textarea>
            <span className="feedback"></span>
            <div className="error">This is the validation message</div>
          </li>
          <li className="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
            <label htmlFor="optionalExample4">Calendar</label>
            <input name="optionalExample4" type="text" className="text-input"/>
            <div className="icon__wrapper icon__wrapper--datepicker">
              <i className="far fa-calendar-alt"></i>
            </div>
            <div className="error">This is the validation message</div>
          </li>
          <li className="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
            <label htmlFor="optionalExample5">Units</label>
            <input type="text" name="optionalExample5" className="text-input has-unit-text"/>
            <div className="input__unit-text">
              Kg
            </div>
            <div className="error">This is the validation message</div>
          </li>
          <li className="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
            <ul className="check-list list-inline">
              <li className="push--right">
                  <input type="radio" name="optionalExampleRadio" id="radio2yes" /> <label htmlFor="radio2yes">Yes</label>
              </li>
              <li>
                  <input type="radio" name="optionalExampleRadio" id="radio2no" checked /> <label htmlFor="radio2no">No</label>
              </li>
            </ul>
            <div className="error">This is the validation message</div>
          </li>
          <li className="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
            <ul className="check-list">
              <li>
                  <input type="checkbox" id="optionalExampleCheck" /> <label htmlFor="optionalExampleCheck">Accept Terms &#38; Conditions</label>
              </li>
            </ul>
            <div className="error">This is the validation message</div>
          </li>
        </ul>
      </div>
      <br/>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
<pre className="hide-code"><code className="language-html">{`<div class="display--inline-block max-width--50 soft-half">
  <h5>Required</h5>
  <ul class="form-fields grid max-width--90">
    <li class="required push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
      <label for="requiredExample1">Username</label>
      <input id="requiredExample1" type="text" class="text-input"/>
      <span class="feedback"></span>
      <div class="error">This is the validation message</div>
    </li>
    <li class="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
      <label for="requiredExample2">Select Country</label>
      <select id="countries" name="requiredExample2" defaultValue="Argentina">
        <option>Argentina</option>
        <option>Albania</option>
        <option>Aruba</option>
      </select>
      <div class="error">This is the validation message</div>
    </li>
    <li class="push-half--bottom grid__col-12">
      <label for="requiredExample3">Comments</label>
      <textarea class="text-input" name="requiredExample3" >Please enter your comments...</textarea>
      <span class="feedback"></span>
      <div class="error">This is the validation message</div>
    </li>
    <li class="required push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
      <label for="requiredExample4">Calendar</label>
      <input id="requiredExample4" type="text" class="text-input"/>
      <div class="icon__wrapper icon__wrapper--datepicker">
        <i class="far fa-calendar-alt"></i>
      </div>
      <div class="error">This is the validation message</div>
    </li>
    <li class="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
      <label for="requiredExample5">Units</label>
      <input type="text" name="requiredExample5" class="text-input has-unit-text"/>
      <div class="input__unit-text">
        Kg
      </div>
      <div class="error">This is the validation message</div>
    </li>
    <li class="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
      <ul class="check-list list-inline">
        <li class="push--right">
            <input type="radio" name="requiredExampleRadio" id="required1yes" /> <label for="required1yes">Yes</label>
        </li>
        <li>
            <input type="radio" name="requiredExampleRadio" id="required1no" checked /> <label for="required1no">No</label>
        </li>
      </ul>
      <div class="error">This is the validation message</div>
    </li>
    <li class="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
      <ul class="check-list">
        <li>
            <input type="checkbox" id="requiredExampleTerms" /> <label for="requiredExampleTerms">Accept Terms &#38; Conditions</label>
        </li>
      </ul>
      <div class="error">This is the validation message</div>
    </li>
  </ul>
  </div>

  <div class="display--inline-block max-width--50 soft-half">
  <h5>Optional</h5>
  <ul class="form-fields grid max-width--90">
    <li class="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
      <label for="optionalExample1">Username</label>
      <input id="optionalExample1" type="text" class="text-input"/>
      <span class="feedback"></span>
      <div class="error">This is the validation message</div>
    </li>
    <li class="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
    <label for="optionalExample2">Select Country</label>
      <select id="countries" name="optionalExample2" defaultValue="Argentina">
        <option>Argentina</option>
        <option>Albania</option>
        <option>Aruba</option>
      </select>
      <div class="error">This is the validation message</div>
    </li>
    <li class="push-half--bottom optional grid__col-12">
      <label for="optionalExample3">Comments</label>
      <textarea class="text-input" name="optionalExample3" >Please enter your comments...</textarea>
      <span class="feedback"></span>
      <div class="error">This is the validation message</div>
    </li>
    <li class="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
      <label for="optionalExample4">Calendar</label>
      <input name="optionalExample4" type="text" class="text-input"/>
      <div class="icon__wrapper icon__wrapper--datepicker">
        <i class="far fa-calendar-alt"></i>
      </div>
      <div class="error">This is the validation message</div>
    </li>
    <li class="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
      <label for="optionalExample5">Units</label>
      <input type="text" name="optionalExample5" class="text-input has-unit-text"/>
      <div class="input__unit-text">
        Kg
      </div>
      <div class="error">This is the validation message</div>
    </li>
    <li class="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
      <ul class="check-list list-inline">
        <li class="push--right">
            <input type="radio" name="optionalExampleRadio" id="radio2yes" /> <label for="radio2yes">Yes</label>
        </li>
        <li>
            <input type="radio" name="optionalExampleRadio" id="radio2no" checked /> <label for="radio2no">No</label>
        </li>
      </ul>
      <div class="error">This is the validation message</div>
    </li>
    <li class="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">
      <ul class="check-list">
        <li>
            <input type="checkbox" id="optionalExampleCheck" /> <label for="optionalExampleCheck">Accept Terms &#38; Conditions</label>
        </li>
      </ul>
      <div class="error">This is the validation message</div>
    </li>
  </ul>
</div>`}</code></pre>
      <br/><br/>

      <h4>Validation examples</h4>

      <p>Error groups</p>
      <div className="alert alert--error">
        <p>Errors:</p>
        <ul className="flush">
          <li>Question 1: This is a required field</li>
          <li>Question 2: Only numbers allowed</li>
          <li>Question 3: Maximum 30 characters</li>
          <li>Question 4: Please enter a valid email address</li>
        </ul>
      </div>
      <br/>

      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
<pre className="hide-code"><code className="language-html">{`<div class="alert alert--error">
  <p>Errors:</p>
  <ul class="flush">
    <li>Question 1: This is a required field</li>
    <li>Question 2: Only numbers allowed</li>
    <li>Question 3: Maximum 30 characters</li>
    <li>Question 4: Please enter a valid email address</li>
  </ul>
</div>`}</code></pre>

      <br/><br/>

      <h4>Vertical forms</h4>

      <div className="soft">
      	<h3>Please sign in</h3>
        <ul className="form-fields max-width--20">
          <li className="required">
            <label htmlFor="username">Username</label>
            <input id="username" type="text" className="text-input has-error" autoComplete="off"/>
            <span className="feedback"></span>
            <div className="error">This is a required field</div>
          </li>
          <li className="required">
            <label htmlFor="password">Password</label>
            <input id="password" type="password" className="text-input is-valid" defaultValue="password" autoComplete="off"/>
            <span className="feedback"></span>
          </li>
      		<li>
      	    <ul className="check-list">
      	      <li>
      	          <input type="checkbox" id="rememberMe"/> <label htmlFor="rememberMe">Remember me?</label>
      	      </li>
      	    </ul>
      	  </li>
      		<li>
      			<button type="button" className="btn">Sign In</button>
      		</li>
        </ul>
      </div>

      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
<pre className="hide-code"><code className="language-html">{`<h3>Please sign in</h3>
<ul class="form-fields">
  <li class="required">
    <label for="username">Username</label>
    <input id="username" type="text" class="text-input has-error" autocomplete="off"/>
    <span class="feedback"></span>
    <div class="error">This is a required field</div>
  </li>
  <li class="required">
    <label for="password">Password</label>
    <input id="password" type="password" class="text-input is-valid" value="password" autocomplete="off"/>
    <span class="feedback"></span>
  </li>
  <li>
    <ul class="check-list">
      <li>
          <input type="checkbox" id="rememberMe"/> <label for="rememberMe">Remember me?</label>
      </li>
    </ul>
  </li>
  <li>
    <button type="button" class="btn">Sign In</button>
  </li>
</ul>`}</code></pre>

    <br/>
    <h4>Horizontal forms</h4>

    <p>Horizontal forms are much more involved to ensure a responsive experience. The below example uses <code className="inline">.list-inline</code>
      to create the sideways flow. An empty label is used to provide consistent spacing for the single checkbox. The helper spacing classes of
      <code className="inline">.soft-half</code> are used to space the content out consistently</p>

    <div className="row soft">
      <h3>Please sign in</h3>
      <ul className="form-fields list-inline">
        <li className="required soft-half">
          <label htmlFor="username">Username</label>
          <input id="username" type="text" className="text-input has-error"/>
          <span className="feedback"></span>
          <div className="error">This is a required field</div>
        </li>
        <li className="required soft-half">
          <label htmlFor="password">Password</label>
          <input id="password" type="password" className="text-input is-valid" defaultValue="password"/>
          <span className="feedback"></span>
        </li>
        <li className="soft-half">
          <label>&nbsp;</label>
          <ul className="check-list">
            <li>
                <input type="checkbox" id="rememberMe"/> <label htmlFor="rememberMe">Remember me?</label>
            </li>
          </ul>
        </li>
        <li className="soft">
          <button type="button" className="btn">Sign In</button>
        </li>
      </ul>
    </div>

    <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
<pre className="hide-code"><code className="language-html">{`<h3>Please sign in</h3>
<ul class="form-fields list-inline">
  <li class="required soft-half">
    <label for="username">Username</label>
    <input id="username" type="text" class="text-input has-error"/>
    <span class="feedback"></span>
    <div class="error">This is a required field</div>
  </li>
  <li class="required soft-half">
    <label for="password">Password</label>
    <input id="password" type="password" class="text-input is-valid" value="password"/>
    <span class="feedback"></span>
  </li>
  <li class="soft-half">
    <label>&nbsp;</label>
    <ul class="check-list">
      <li>
          <input type="checkbox" id="rememberMe"/> <label for="rememberMe">Remember me?</label>
      </li>
    </ul>
  </li>
  <li class="soft">
    <button type="button" class="btn">Sign In</button>
  </li>
</ul>`}</code></pre>

    <br/>

    <h4>Inputs with icons</h4>

    <p>On text fields containing an icon to the right, add optional class '.has-icon-right' to the input to prevent text covering the icon</p>

    <ul className="form-fields grid">
      <li className="required grid__col-xs-6 grid__col-sm-6 grid__col-md-4 grid__col-lg-3">
        <label>Email</label>
        <input type="text" className="text-input has-icon-right is-valid"/>
        <span className="feedback"></span>
        <div className="icon__wrapper icon__wrapper--right">
          <i className="fa fa-envelope"></i>
        </div>
      </li>
      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-4 grid__col-lg-3">
        <label>Phone No.</label>
        <input type="text" className="text-input has-icon-right"/>
        <div className="icon__wrapper icon__wrapper--right">
          <i className="fa fa-phone"></i>
        </div>
      </li>
      <li className="required grid__col-xs-6 grid__col-sm-6 grid__col-md-4 grid__col-lg-3">
        <label>Calendar</label>
        <input type="text" className="text-input has-icon-right has-error"/>
        <span className="feedback"></span>
        <div className="icon__wrapper icon__wrapper--datepicker">
          <i className="far fa-calendar-alt"></i>
        </div>
        <div className="error">This is a required field</div>
      </li>
    </ul>
    <br />
    <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
<pre className="hide-code"><code className="language-html">{`<ul className="form-fields grid">
  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2">
    <label>Email (icon aligned left)</label>
    <input type="text" className="text-input is-valid"/>
    <span className="feedback"></span>
    <div className="icon__wrapper icon__wrapper--right">
      <i className="fa fa-envelope"></i>
    </div>
  </li>
  <li className="required grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2">
    <label>Phone No. (icon aligned right)</label>
    <input type="text" className="text-input"/>
    <div className="icon__wrapper icon__wrapper--right">
      <i className="fa fa-phone"></i>
    </div>
  </li>
  <li className="required grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2">
    <label>Calendar</label>
    <input type="text" className="text-input has-error"/>
    <span className="feedback"></span>
    <div className="icon__wrapper icon__wrapper--datepicker">
      <i className="far fa-calendar-alt"></i>
    </div>
    <div className="error">This is a required field</div>
  </li>
</ul>`}</code></pre>

    <br/><br/>

    <h4>Inputs with Unit Text</h4>

    <p>On text fields containing unit text, add optional class '.has-unit-text' to the input to prevent text covering the icon</p>

    <ul className="form-fields grid">
      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2">
        <label>Units</label>
        <input type="text" className="text-input has-unit-text"/>
        <div className="input__unit-text">
            Kg
        </div>
      </li>
      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2">
        <label>Amount</label>
        <input type="text" className="text-input has-unit-text"/>
        <div className="input__unit-text">
            $USD
        </div>
      </li>
      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2">
        <label>Amount</label>
        <input type="text" className="text-input has-unit-text"/>
        <div className="input__unit-text">
            £GBP
        </div>
      </li>
      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2">
        <label>Amount</label>
        <input type="text" className="text-input has-unit-text"/>
        <div className="input__unit-text">
            €EUR
        </div>
      </li>
    </ul>
    <br />
    <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
    <pre className="hide-code"><code className="language-html">{`<ul className="form-fields grid">
      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2">
        <label>Units</label>
        <input type="text" className="text-input"/>
        <div className="input__unit-text">
            Kg
        </div>
      </li>
      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2">
        <label>Amount</label>
        <input type="text" className="text-input"/>
        <div className="input__unit-text">
            $USD
        </div>
      </li>
      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2">
        <label>Amount</label>
        <input type="text" className="text-input"/>
        <div className="input__unit-text">
            £GBP
        </div>
      </li>
      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2">
        <label>Amount</label>
        <input type="text" className="text-input"/>
        <div className="input__unit-text">
            €EUR
        </div>
      </li>
    </ul>`}</code></pre>

        <br/><br/>
    <hr/>
    </section>
  )
}
}

export default Forms



// WEBPACK FOOTER //
// ./styleguide/components/sections/Forms.js